<template>
  <div id="app">
    <header>
      <Header
        @animationstart.native="onAnimationStart"
        :class="{ [animationName]: $route.name === 'home' }"
        :fixedToTop="$route.path === '/'"
        ref="header"
        :theme-color="themeColor"
      ></Header>
    </header>
    <main style="padding-top: 80px">
      <!-- <div class="notice-bar">
        <div class="scroll-text">
          📢
          运维提醒：湖北省残疾人就业服务中心拟于9月11日22:00-24:00对湖北省残疾人求职招聘信息平台进行维护，期间可能影响网站正常使用，敬请谅解。
        </div>
      </div> -->
      <transition appear :name="pageTransitionName">
        <router-view :key="$route.path"></router-view>
      </transition>
    </main>
    <footer>
      <Footer></Footer>
    </footer>
    <div class="returnTop" @click="scrollToTop">
      <svg
        data-v-ce04894c=""
        width="30"
        height="30"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        class="icon-top"
      >
        <path
          data-v-ce04894c=""
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.00806 3.0625C4.70158 3.0625 4.45312 3.31095 4.45312 3.61743C4.45312 3.92391 4.70158 4.17236 5.00806 4.17236H14.9968C15.3033 4.17236 15.5518 3.92391 15.5518 3.61743C15.5518 3.31095 15.3033 3.0625 14.9968 3.0625H5.00806ZM10.3948 5.9997C10.1781 5.78297 9.82676 5.78297 9.61005 5.9997L6.07849 9.53126C5.86176 9.74797 5.86176 10.0993 6.07849 10.316C6.2952 10.5328 6.64656 10.5328 6.86327 10.316L9.44751 7.73182V17.3809C9.44751 17.6873 9.69596 17.9358 10.0024 17.9358C10.3089 17.9358 10.5574 17.6873 10.5574 17.3809V7.73182L13.1416 10.316C13.3583 10.5328 13.7097 10.5328 13.9264 10.316C14.1431 10.0993 14.1431 9.74797 13.9264 9.53126L10.3948 5.9997Z"
          stroke-width="0.5"
        ></path>
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      homeScrollY: 0,
      pageTransitionName: "",
      animationName: "",
      newRoute: "",
      show: false,
    };
  },
  computed: {
    themeColor() {
      return this.$route.path !== "/"
        ? "main-color"
        : this.homeScrollY < Math.max(400, window.innerHeight)
        ? "is-transparent"
        : "main-color";
    },
  },
  created() {
    // this.$root.$on("home-scrolling", (direction, pos) => {
    //   this.homeScrollY = pos.y;
    //   if (direction.directionY === -1) {
    //     this.animationName = "slideInDown";
    //   } else {
    //     this.animationName = "slideOutUp";
    //   }
    // });
  },
  mounted() {
    this.$refs.header.$el.addEventListener("animationend", function (e) {
      if (e.animationName === "slideOutUp") {
        e.target.style.top = "-100%";
      }
    });

    // 监听 localStorage 变化（同域名下所有标签页生效）
    window.addEventListener("storage", this.handleStorageChange);
  },
  watch: {
    $route(newRoute) {
      this.pageTransitionName = ["products", "home"].includes(newRoute.name)
        ? ""
        : "jumpPage";
      this.newRoute = newRoute.name;
    },
  },
  methods: {
    onAnimationStart(e) {
      if (e.animationName === "slideInDown") {
        e.target.style.top = 0;
      }
    },
    scrollToTop() {
      this.$scrollToTop();
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 1000);
    },

    handleStorageChange(event) {
      if (event.key === "isLogin") {
        this.updateLoginStatus();
      }
    },

    updateLoginStatus() {
      // 更新 Vuex/Pinia 状态
      this.$store.commit("SET_STATUS", true);
      // 重新用户状态
      this.$store.dispatch("GetUserOpen");
      // 重新获取用户信息
      this.$store.dispatch("GetInfo");
    },
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener("storage", this.handleStorageChange);
  },
};
</script>
<style lang="less">
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes slideOutUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-100%);
  }
}
// .notice-bar {
//   width: 100%;
//   height: 36px;
//   line-height: 36px;
//   background: #fff7e6;
//   border: 1px solid #ffd591;
//   overflow: hidden;
//   display: flex;
//   align-items: center;
// }
// .scroll-text {
//   white-space: nowrap;
//   animation: marquee 15s linear infinite;
//   color: #d48806;
// }

// @keyframes marquee {
//   0% {
//     transform: translateX(100%);
//   }
//   100% {
//     transform: translateX(-100%);
//   }
// }
.slideInDown {
  animation: slideInDown 0.4s;
}
.slideOutUp {
  animation: slideOutUp 0.4s;
}

.jumpPage-leave-active {
  display: none;
}
.jumpPage-enter {
  transform: translate3d(0, 80px, 0);
  opacity: 0;
}

.jumpPage-enter-active {
  transition: all 0.3s;
}
#app {
  min-width: 1200px;
}

.returnTop {
  position: fixed;
  bottom: 3em;
  right: 2em;
  z-index: 999;
  margin: 1rem 0 0;
  padding: 0;
  width: 3.33rem;
  height: 3.33rem;
  line-height: 1;
  color: #909090;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0px 9px 20px 0px #c2c1c180;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
